module.exports = __webpack_public_path__ + "static/media/chess-clock.af60f846.svg";